import { Icon } from "@iconify/react/dist/iconify.js";
import colors from "../../theme/colors";
import Loader from "../../utils/Loader";

const CommonButton = ({
  title,
  height = 44,
  onClick,
  disabled = false,
  loading = false,
  width = 320,
  icon,
  iconPosition = "left", // "left" | "right"
  variant = "filled", // 'filled' | 'outline'
  type = "button",
  style = {}
}) => {
  // Styles for each variant
  const baseStyle = {
    width: typeof width === "number" ? `${width}px` : width,
    height: typeof height === "number" ? `${height}px` : height,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 12,
    fontSize: 14,
    fontFamily: 'PlusJakartaSans-SemiBold, sans-serif',
    fontWeight: 600,
    cursor: (disabled || loading) ? 'not-allowed' : 'pointer',
    outline: 'none',
    boxSizing: 'border-box',
    marginTop: 12,
    padding: "0 10px",
    transition: 'opacity 0.2s, color 0.2s, background 0.2s, border 0.2s',
    opacity: (disabled || loading) ? 0.6 : 1,
    ...style
  };

  const filledStyle = {
    ...baseStyle,
    border: 'none',
    background: (disabled || loading)
      ? "var(--brand-gradient-disabled)"
      : "var(--brand-gradient)",
    color: "var(--text-on-brand)",
  };
  const outlineStyle = {
    ...baseStyle,
    border: '1.5px solid var(--border-outline)',
    background: "var(--bg-surface)",
    color: "var(--text-primary)",
  };

  const dashed = {
    ...baseStyle,
    border: (disabled || loading) ? '2px dashed var(--border-subtle)' : '2px dashed ' + colors.themeColor,
    background: style.background || "var(--bg-surface-2)",
    color: (disabled || loading) ? 'var(--text-muted)' : (style.color || "var(--text-primary)"),
  }

  const dangerStyle = {
    ...baseStyle,
    border: '1.5px solid ' + colors.danger,
    background: "var(--bg-surface-2)",
    color: "var(--text-primary)",
  };

  let finalStyle = variant === "filled" ? filledStyle : variant === "outline" ? outlineStyle: variant === "danger" ? dangerStyle : dashed;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className="text-decoration-none hover-interactive"
      style={finalStyle}
    >
      {loading ? (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
          <Loader variant="dots" size="small" color={variant === "filled" ? "white" : "primary"} />
          <span>{title}..</span>
        </div>
      ) : (
        <>
          {icon && iconPosition === "left" && (
            <span style={{ marginRight: 8, display: 'flex', alignItems: 'center' }}>
              <Icon icon={icon} width={18} height={18} color={variant === "filled" ? "white" : (disabled || loading) ? "var(--text-muted)" : "var(--text-primary)"} />
            </span>

          )}
          {title}
          {icon && iconPosition === "right" && (
            <span style={{ marginLeft: 8, display: 'flex', alignItems: 'center' }}>
              <Icon icon={icon} width={18} height={18} color={variant === "filled" ? "white" : (disabled || loading) ? "var(--text-muted)" : "var(--text-primary)"} />
            </span>

          )}
        </>
      )}
    </button>
  );
};

export default CommonButton;
